import { render, staticRenderFns } from "./IconTitleValueCardComponent.vue?vue&type=template&id=38365623&scoped=true&"
import script from "./IconTitleValueCardComponent.vue?vue&type=script&lang=js&"
export * from "./IconTitleValueCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./IconTitleValueCardComponent.vue?vue&type=style&index=0&id=38365623&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38365623",
  null
  
)

export default component.exports